import type { TAtendimentoEncerradoResponse } from '@/features/atendimento/interfaces'
import { HttpService } from '@/shared/lib'

export class EncerrarAtendimentoService extends HttpService {
  async execute(id: string) {
    const response = await this.http.patch<TAtendimentoEncerradoResponse>(
      `/api/v2/Atendimento/encerrarAtendimento/${id}`,
      {},
    )
    return response.data
  }
}
